import { devWarning } from '.';

export type Point = {
    x: number;
    y: number;
}

/**
 * Rounds the given number to the desired decimal places.
 */
export function roundDecimals(n: number, decimals: number): number {
    const factor = decimals < 0 ? 1 : Math.pow(10, decimals);

    if (decimals < 0) {
        devWarning(
            `Unexpected param value: 'decimals' was '${decimals}', but negative numbers are not allowed for this method.`,
        );
    }

    return Math.round(n * factor) / factor;
}

export function compareNumbers(
    a: number | undefined,
    b: number | undefined,
    invert: boolean,
): number {
    if (a !== null && b !== null && a !== undefined && b !== undefined) {
        if (a === b) {
            return 0;
        }
        if (invert) {
            return a < b ? 1 : -1;
        } else {
            return a > b ? 1 : -1;
        }
    }

    return 0;
}

export function getVector(
    p1: Point,
    p2: Point,
): Point {
    return {
        x: p2.x - p1.x,
        y: p2.y - p1.y,
    };
}
